import axios from 'axios';

// Base URL for the API
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.edunasser.bytelogs.cloud';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - DO NOT auto-logout on 401
// Let errors propagate to UI for graceful handling
// User will only be logged out when they explicitly click logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Just reject the error - don't auto-logout
    // The UI components will handle showing appropriate error messages
    return Promise.reject(error);
  }
);

export default api;
